module.exports = __webpack_public_path__ + "static/media/IMG_2737.8280476b.jpg";